var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SylController, SylPlugin } from '@syllepsis/adapter';
import { AllSelection } from 'prosemirror-state';
import { checkParentSupportAttr } from '../../utils';
var PLUGIN_NAME = 'line_indent';
var LineIndentController = /** @class */ (function (_super) {
    __extends(LineIndentController, _super);
    function LineIndentController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.attrName = 'lineIndent';
        _this.toolbar = {
            handler: function (editor) {
                var _a;
                _this.command.setTypeset(editor, (_a = {}, _a[_this.attrName] = _this.active(editor) ? '' : _this.props.value || 2, _a));
            },
        };
        _this.command = {
            setTypeset: function (editor, attrs) {
                editor.nodesBetween(function (node, nodePos) {
                    if (node.isTextblock) {
                        editor.update(attrs, nodePos);
                        return false;
                    }
                });
                editor.focus();
            },
        };
        _this.active = function (editor) {
            var isActive = false;
            editor.nodesBetween(function (node) {
                if (isActive)
                    return false;
                if (node.isTextblock) {
                    isActive = Boolean(node.attrs[_this.attrName]);
                    return false;
                }
            });
            return isActive;
        };
        _this.disable = function (editor) {
            var selection = editor.view.state.selection;
            return !(selection instanceof AllSelection) && !checkParentSupportAttr(editor.view, _this.attrName);
        };
        return _this;
    }
    return LineIndentController;
}(SylController));
var LineIndentPlugin = /** @class */ (function (_super) {
    __extends(LineIndentPlugin, _super);
    function LineIndentPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = PLUGIN_NAME;
        _this.Controller = LineIndentController;
        return _this;
    }
    return LineIndentPlugin;
}(SylPlugin));
export { LineIndentController, LineIndentPlugin };
//# sourceMappingURL=index.js.map